import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';

import images from '../../../static/images/RealtorLanding';
import * as styles from './TabEstateBoard.scss';

class TabEstateBoard extends Component {
  render() {
    const translate = this.props.translate('NavTabs', 'allAdsTogether');

    return (
      <div className={styles.tabWrapper}>
          <div className={styles.textWrapper}>
            <p>{translate('title')}</p>
            <p>{translate('foreword')}</p>
            <p>{translate('blockValue')}</p>
          </div>
          <div className={styles.photoWrapper}>
              <img src={images.privateBrokerage} alt="realtor" />
          </div>
      </div>
    );
  }
}

TabEstateBoard.propTypes = {
  translate: PropTypes.func
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'RealtorLanding')
});

export default connect(mapStateToProps)(TabEstateBoard);
